import { render, staticRenderFns } from "./ContactDialogEdit.vue?vue&type=template&id=45780428&scoped=true&"
import script from "./ContactDialogEdit.vue?vue&type=script&lang=js&"
export * from "./ContactDialogEdit.vue?vue&type=script&lang=js&"
import style0 from "./ContactDialogEdit.vue?vue&type=style&index=0&id=45780428&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45780428",
  null
  
)

export default component.exports